<template>
  <el-container class="chat-page">
    <resizable-aside
        :default-width="230"
        :min-width="200"
        :max-width="500"
        storage-key="chat-aside-width"
        class="aside"
        :class="{ fullscreen: configStore.fullScreen }">
      <div class="header" :class="configStore.electronMode ? 'header-menu-wrap' : ''">
        <el-input class="search-text" size="small" placeholder="搜索" v-model="searchText">
          <i class="el-icon-search el-input__icon" slot="prefix"> </i>
        </el-input>
      </div>
      <div class="chat-loading" v-if="loading" v-loading="true" element-loading-text="消息接收中..."
           element-loading-spinner="el-icon-loading" element-loading-background="#F9F9F9" element-loading-size="24">
      </div>
      <virtual-scroller
          ref="scroller"
          v-else
          class="chat-items"
          :items="visibleList"
          :itemHeight="54"
          :size="30"
          v-slot="{ item, index }">
        <chat-item
            :chat="item"
            :index="index"
            :active="item === chatStore.activeChat"
            :highlighted-chat="highlightedChat"
            @click.native="onActiveItem(item)"
            @delete="onDelItem(item)"
            @info="onShowInfo(item)"
            @dnd="onDnd(item)"
            @top="onTop(item)"
            @markasunread="onMarkAsUnread(item)"
            :data-chat-id="item.targetId"
            :data-type="item.type"
            :data-target-id="item.targetId"
        />
      </virtual-scroller>
    </resizable-aside>
    <el-container class="chat-box">
      <chat-box ref="chatBox" v-if="activeChat && activeChat.type != 'SYSTEM'" :chat="activeChat"></chat-box>
      <chat-system-box v-if="activeChat && activeChat.type == 'SYSTEM'" :chat="activeChat"></chat-system-box>
    </el-container>

    <!-- ✅ 右侧快捷回复侧边栏 -->
    <div
        class="quick-reply-sidebar"
        v-if="isElectron && activeChat && activeChat.type != 'SYSTEM'"
        v-show="showQuickReply">
      <div class="quick-reply-header">
        <el-icon name="chat-dot-round" style="margin-right: 8px;"></el-icon>
        <span>快捷回复</span>
        <el-button
            type="text"
            icon="el-icon-plus"
            @click="openAddDialog"
            style="margin-left: auto; padding: 0 10px;"
            title="新增快捷回复">
        </el-button>
      </div>
      <div class="quick-reply-list">
        <!-- 空状态提示 -->
        <div v-if="quickReplies.length === 0" class="quick-reply-empty">
          暂无快捷回复<br>
          <el-link type="primary" @click="openAddDialog">立即添加</el-link>
        </div>

        <div
            v-else
            v-for="reply in quickReplies"
            :key="reply.id"
            class="quick-reply-item-wrapper">
          <div
              class="quick-reply-item"
              @click="insertQuickReply(reply.content)"
              :title="reply.content">
            <div class="quick-reply-content">
              {{ reply.title ? reply.title : reply.content }}
            </div>
          </div>
          <div class="quick-reply-actions" @click.stop>
            <i
                class="el-icon-edit"
                @click="openEditDialog(reply)"
                title="编辑">
            </i>
            <i
                class="el-icon-delete"
                @click="handleDelete(reply)"
                title="删除">
            </i>
          </div>
        </div>
      </div>
    </div>

    <!-- ✅ 快捷回复切换按钮 -->
    <div
        class="quick-reply-toggle"
        v-if="isElectron && activeChat && activeChat.type != 'SYSTEM'"
        @click="toggleQuickReply"
        :title="showQuickReply ? '隐藏快捷回复(快捷键ctrl+/)' : '显示快捷回复(快捷键ctrl+/)'">
      <i :class="showQuickReply ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"></i>
    </div>

    <!-- 编辑对话框 -->
    <el-dialog
        :title="isEditing ? '编辑快捷回复' : '新增快捷回复'"
        :visible.sync="dialogVisible"
        width="400px"
        append-to-body>
      <el-form :model="currentReply" label-width="60px" :rules="formRules" ref="replyForm">
        <el-form-item label="标题">
          <el-input v-model="currentReply.title" placeholder="请输入标题（可选）没有则显示内容" clearable></el-input>
        </el-form-item>
        <!-- 新增排序字段 -->
        <el-form-item label="排序">
          <el-input-number
              v-model="currentReply.sort"
              :min="0"
              :max="9999"
              size="small"
              style="width: 100%"
              placeholder="数字越小越靠前">
          </el-input-number>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input
              type="textarea"
              :rows="4"
              v-model="currentReply.content"
              placeholder="请输入快捷回复内容"
              maxlength="500"
              show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="saveQuickReply" :loading="saving" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import ChatItem from "../components/chat/ChatItem.vue";
import ChatBox from "../components/chat/ChatBox.vue";
import ChatSystemBox from "../components/chat/ChatSystemBox.vue";
import VirtualScroller from '../components/common/VirtualScroller2.vue';
import ResizableAside from '../components/common/ResizableAside.vue';

export default {
  name: "chat",
  components: {
    ChatItem,
    ChatBox,
    ChatSystemBox,
    VirtualScroller,
    ResizableAside
  },
  data() {
    return {
      searchText: "",
      messageContent: "",
      group: {},
      groupMembers: [],
      highlightedChat: null,
      quickReplies: [],
      // ✅ 新增：快捷回复显示状态
      showQuickReply: true,
      // 编辑对话框相关数据
      dialogVisible: false,
      currentReply: {
        id: null,
        content: '',
        sort: 0,
        title: ''
      },
      isEditing: false,
      saving: false,
      formRules: {
        content: [
          {required: true, message: '内容不能为空', trigger: 'blur'},
          {min: 1, max: 500, message: '长度在 1 到 500 个字符', trigger: 'blur'}
        ],
        sort: [  // 添加排序字段验证
          {type: 'number', min: 0, max: 9999, message: '排序值必须在 0-9999 之间', trigger: 'blur'}
        ]
      }
    }
  },
  computed: {
    activeChat() {
      return this.chatStore.activeChat;
    },
    loading() {
      return this.chatStore.loading
    },
    visibleList() {
      const thisText = this.searchText.toLowerCase().trim();
      return this.chatStore.chats
          .filter(c => !c.delete && c.showName && c.showName.toLowerCase().includes(thisText))
          .map(c => {
            if (!c.id) c.id = `${c.type}_${c.targetId}`;
            return c;
          });
    },
    // Electron 环境检测
    isElectron() {
      return process.versions && !!process.versions.electron ||
          process.env && process.env.IS_ELECTRON ||
          window.navigator.userAgent.includes('Electron');
    }
  },
  methods: {
    // ✅ 新增：切换快捷回复显示/隐藏
    toggleQuickReply() {
      this.showQuickReply = !this.showQuickReply;
      localStorage.setItem('quickReplySidebarVisible', JSON.stringify(this.showQuickReply));
    },

    // ✅ 新增：键盘事件处理
    handleKeyDown(e) {
      // Ctrl+/ 或 Cmd+/ 切换快捷回复
      if ((e.ctrlKey || e.metaKey) && e.key === '/') {
        e.preventDefault();
        this.toggleQuickReply();
      }
    },

    // 打开新增对话框
    openAddDialog() {
      this.currentReply = {
        id: null,
        content: '',
        title: '',
        sort: 0
      };
      this.isEditing = false;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.replyForm?.clearValidate();
      });
    },

    // 打开编辑对话框
    openEditDialog(reply) {
      this.currentReply = {
        id: reply.id,
        content: reply.content,
        title: reply.title,
        sort: reply.sort
      };
      this.isEditing = true;
      this.dialogVisible = true;
    },

    // 保存快捷回复（新增或编辑）
    saveQuickReply() {
      this.$refs.replyForm.validate((valid) => {
        if (!valid) return;

        this.saving = true;
        const dto = {
          content: this.currentReply.content,
          title: this.currentReply.title,
          sort: this.currentReply.sort || 0
        };

        // 如果是编辑模式，添加 ID 字段
        if (this.isEditing) {
          dto.id = this.currentReply.id;
        }

        this.$http({
          url: '/user/addQuickReplies',
          method: 'put', // 根据是否编辑决定方法
          data: dto
        }).then(() => {
          this.$message.success(this.isEditing ? '编辑成功' : '添加成功');
          this.dialogVisible = false;
          this.loadQuickReplies();
        }).catch(error => {
          this.$message.error((this.isEditing ? '编辑失败' : '添加失败') + ': ' + (error.response?.data?.message || error.message));
        }).finally(() => {
          this.saving = false;
        });
      });
    },

    // 获取快捷回复列表（直接使用后台返回的顺序）
    loadQuickReplies() {
      this.$http({
        url: '/user/quickRepliesList',
        method: 'get'
      }).then(res => {
        this.quickReplies = res || [];
      }).catch(error => {
        this.$message.error('加载快捷回复失败: ' + error.message);
      });
    },

    // 删除快捷回复（带确认）
    handleDelete(reply) {
      this.$confirm(`确定删除快捷回复"${reply.title || reply.content}"吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.removeQuickReply(reply.id);
      }).catch(() => {});
    },

    // 执行删除
    removeQuickReply(id) {
      this.$http({
        url: `/user/removeQuickReplies/${id}`,
        method: 'delete'
      }).then(() => {
        this.$message.success('删除成功');
        this.loadQuickReplies();
      }).catch(error => {
        this.$message.error('删除失败: ' + (error.response?.data?.message || error.message));
      });
    },

    // 插入快捷回复到输入框
    insertQuickReply(replyText) {
      if (!this.activeChat || this.activeChat.type === 'SYSTEM') {
        this.$message.warning('请选择一个有效的聊天');
        return;
      }
      if (this.$refs.chatBox) {
        this.$refs.chatBox.insertQuickReply(replyText);
        this.$message.success('已插入快捷回复');
      }
    },

    onActiveItem(chat) {
      this.chatStore.setActiveChat(chat);
    },
    onDelItem(chat) {
      this.chatStore.removeChat(chat);
    },
    onShowInfo(chat) {
      if (chat.type == 'PRIVATE') {
        this.$router.push("/home/friend?id=" + chat.targetId);
      } else if (chat.type == 'GROUP') {
        if (!this.groupStore.isGroup(chat.targetId)) {
          this.$message.error("您已不在群聊中，无法查看群资料")
          return;
        }
        this.$router.push("/home/group?id=" + chat.targetId);
      }
    },
    onDnd(chat) {
      if (chat.type == 'PRIVATE') {
        this.setFriendDnd(chat, chat.targetId, !chat.isDnd)
      } else {
        this.setGroupDnd(chat, chat.targetId, !chat.isDnd)
      }
    },
    setFriendDnd(chat, friendId, isDnd) {
      let formData = { friendId: friendId, isDnd: isDnd }
      this.$http({ url: '/friend/dnd', method: 'put', data: formData })
          .then(() => {
            this.friendStore.setDnd(friendId, isDnd)
            this.chatStore.setDnd(chat, isDnd)
          })
    },
    setGroupDnd(chat, groupId, isDnd) {
      let formData = { groupId: groupId, isDnd: isDnd }
      this.$http({ url: '/group/dnd', method: 'put', data: formData })
          .then(() => {
            this.groupStore.setDnd(groupId, isDnd)
            this.chatStore.setDnd(chat, isDnd)
          })
    },
    onTop(chat) {
      if (chat.type == 'PRIVATE') {
        this.setFriendTop(chat, chat.targetId, !chat.isTop)
      } else {
        this.setGroupTop(chat, chat.targetId, !chat.isTop)
      }
    },
    setFriendTop(chat, friendId, isTop) {
      let formData = { friendId: friendId, isTop: isTop }
      this.$http({ url: '/friend/top', method: 'put', data: formData })
          .then(() => {
            this.friendStore.setTop(friendId, isTop)
            this.chatStore.setTop(chat, isTop)
          })
    },
    setGroupTop(chat, groupId, isTop) {
      let formData = { groupId: groupId, isTop: isTop }
      this.$http({ url: '/group/top', method: 'put', data: formData })
          .then(() => {
            this.groupStore.setTop(groupId, isTop)
            this.chatStore.setTop(chat, isTop)
          })
    },
    onMarkAsUnread(chat) {
      let lastMessageId = null;
      if (chat.messages && chat.messages.length > 0) {
        const lastMessage = chat.messages[chat.messages.length - 1];
        lastMessageId = lastMessage.id || lastMessage.tmpId;
      }
      if (lastMessageId) {
        this.chatStore.markMessageAsUnread(chat, lastMessageId);
        chat.unreadCount = chat.unreadCount + 1;
        chat.stored = false;
        this.chatStore.saveToStorage();
        this.$message.success('已标记为未读');
      } else {
        this.$message.warning('无法标记为未读：没有找到消息');
      }
    },
    flashChatItem(chat) {
      this.searchText = '';
      this.$nextTick(() => {
        const index = this.visibleList.findIndex(
            c => c.type === chat.type && c.targetId === chat.targetId
        );
        if (index === -1) return;
        this.$nextTick(() => {
          if (this.$refs.scroller) {
            this.$refs.scroller.scrollToIndex(index);
            this.highlightedChat = chat;
            setTimeout(() => {
              this.highlightedChat = null;
            }, 500);
          }
        });
      });
    }
  },
  mounted() {
    this.$eventBus.$on('flashChatItem', this.flashChatItem);
    if (this.isElectron){
      this.loadQuickReplies();
    }

    // ✅ 新增：从本地存储恢复显示状态
    const savedState = localStorage.getItem('quickReplySidebarVisible');
    if (savedState !== null) {
      this.showQuickReply = JSON.parse(savedState);
    }

    // ✅ 新增：监听键盘事件
    document.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    this.$eventBus.$off('flashChatItem', this.flashChatItem);
    document.removeEventListener('keydown', this.handleKeyDown); // ✅ 移除监听
  }
}
</script>

<style lang="scss">
.chat-page {
  display: flex;
  flex-direction: row;
  height: 100vh;
  overflow: hidden;

  .chat-box {
    flex: 1;
    overflow: hidden;
  }

  // ✅ 右侧快捷回复侧边栏样式
  .quick-reply-sidebar {
    width: 200px;
    min-width: 200px;
    max-width: 300px;
    background-color: #fafafa;
    border-left: 1px solid rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    height: 100%;
    transition: all 0.3s ease;

    .quick-reply-header {
      height: 60px;
      display: flex;
      align-items: center;
      padding: 0 12px;
      font-size: 14px;
      font-weight: 600;
      color: var(--im-text-color);
      border-bottom: 1px solid #e0e0e0;
      background-color: #fff;
      box-sizing: border-box;

      .el-button {
        padding: 5px;
        font-size: 16px;
        color: #409EFF;

        &:hover {
          color: #66b1ff;
          transform: scale(1.1);
        }
      }
    }

    .quick-reply-list {
      flex: 1;
      overflow-y: auto;
      padding: 10px;
      background-color: #f9f9f9;

      // 滚动条美化
      &::-webkit-scrollbar {
        width: 6px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #c1c1c1;
        border-radius: 3px;
      }

      // 空状态提示
      .quick-reply-empty {
        text-align: center;
        color: #999;
        font-size: 12px;
        padding: 20px 0;
      }

      .quick-reply-item-wrapper {
        position: relative;
        margin-bottom: 8px;
        transition: all 0.2s ease;

        &:hover {
          transform: translateY(-1px);
        }

        .quick-reply-item {
          padding: 10px 12px;
          background-color: white;
          border-radius: 6px;
          cursor: pointer;
          font-size: 12px;
          color: var(--im-text-color);
          transition: all 0.2s ease;
          border: 1px solid transparent;
          padding-right: 60px; // 为操作按钮预留空间

          // 文本溢出处理
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          &:hover {
            background-color: #e3f2fd;
            border-color: #bbdefb;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            white-space: normal;
            word-break: break-word;
          }

          &:active {
            transform: translateY(0);
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
          }

          .quick-reply-content {
            line-height: 1.4;
          }
        }

        .quick-reply-actions {
          position: absolute;
          right: 8px;
          top: 50%;
          transform: translateY(-50%);
          display: flex;
          gap: 5px;
          opacity: 0;
          transition: opacity 0.2s ease;

          i {
            font-size: 14px;
            cursor: pointer;
            padding: 4px;
            border-radius: 4px;
            transition: all 0.2s ease;

            &.el-icon-edit {
              color: #409EFF;

              &:hover {
                background-color: #e6f2ff;
              }
            }

            &.el-icon-delete {
              color: #F56C6C;

              &:hover {
                background-color: #fef0f0;
              }
            }

            &:hover {
              transform: scale(1.1);
            }
          }
        }

        &:hover .quick-reply-actions {
          opacity: 1;
        }
      }
    }
  }

  // ✅ 新增：快捷回复切换按钮样式
  .quick-reply-toggle {
    position: absolute;
    right: 10px;
    bottom: 70px;
    width: 15px;
    height: 15px;
    background-color: #409EFF;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
    z-index: 1000;
    transition: all 0.3s ease;

    &:hover {
      background-color: #66b1ff;
      transform: scale(1.1);
    }

    i {
      color: white;
      font-size: 16px;
    }
  }

  .aside {
    display: flex;
    flex-direction: column;
    border-right: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);

    &.fullscreen {
      width: 260px !important;

      @media (min-width: 1200px) {
        width: 290px !important;
      }
    }

    .header {
      height: 60px;
      display: flex;
      align-items: center;
      padding: 0 12px;
    }

    .chat-loading {
      height: 50px;
      background-color: #eee;

      .el-icon-loading {
        font-size: 24px;
        color: var(--im-text-color-light);
      }

      .el-loading-text {
        color: var(--im-text-color-light);
      }

      .chat-loading-box {
        height: 100%;
      }
    }

    .chat-items {
      flex: 1;
    }
  }
}

.flash-highlight {
  background-color: #fff3cd !important;
  transition: background-color 0.3s;
}
</style>